export default "__VITE_ASSET__Bhd_vxGf__"